// Iter388 — Small helper for the Owner "Back to Festival Manager"
// nav. AdminFestivals sets the flag on any card click; every festival
// sub-page reads it to decide whether the back-link should point at
// /admin/festivals (Owner arrived via admin console) or /festival/mine
// (organiser opened their own festival). Session-scoped so a hard
// refresh preserves the trail; cleared when Owner explicitly clicks
// the back link.
const KEY = "adminFestivalManagerEntry";
export function markAdminFestivalEntry() {
  try { sessionStorage.setItem(KEY, "1"); } catch {}
}
export function isFromAdminFestivals() {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}
export function clearAdminFestivalEntry() {
  try { sessionStorage.removeItem(KEY); } catch {}
}
